module.exports = __webpack_public_path__ + "static/media/media-outlets-prod.e24c3069.svg";